export default __webpack_public_path__ + "static/media/security-icon.7014a249.svg";